import { render, staticRenderFns } from "./finance-profit-report.vue?vue&type=template&id=4935869a&scoped=true&"
import script from "./finance-profit-report.vue?vue&type=script&lang=js&"
export * from "./finance-profit-report.vue?vue&type=script&lang=js&"
import style0 from "./finance-profit-report.vue?vue&type=style&index=0&id=4935869a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935869a",
  null
  
)

export default component.exports